// src/components/Data/expert-pre-load-database.js

// Minimal, synchronous, in-bundle cache of high-priority experts.
// Keyed by the Qwoted global_id (string).
// Add as many as you want — these render instantly before any network/db work.

export const PRELOADED_EXPERTS = {
  // Suze Orman
  "155776": {
    id: "155776",
    name: "Suze Orman",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1749142227/production-TjoCZY/a044e99ce864acea1d39/1749142227.png",
    title: "Personal Finance Expert at Suze Orman Media",
    description:
      "Suze Orman is a renowned personal finance expert, bestselling author, and motivational speaker known for her candid, empowering advice on money management. Orman began her career a..."
  },

  // Sarah Keenleyside
  "107540": {
    id: "107540",
    name: "Sarah Keenleyside",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1703913656/production-TjoCZY/097874a41854e40f4f98/1703913656.jpg",
    title: 'Host and Co-Host of "Backyard Builds" at HGTV',
    description:
      "Sarah is a full service residential and commercial design firm, based in Prince Edward County, Canada. Led by Principal Designer Sarah Keenleyside, we specialize in creating unique..."
  },

  // Tarek El Moussa
  "57269": {
    id: "57269",
    name: "Tarek El Moussa",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1560532976/production-TjoCZY/2d00647deb3a01514419/1560532976.png",
    title: 'Host "Flipping 101 w Tarek El Moussa"; Co-Host ... at HGTV',
    description:
      "Self-made celebrity real estate investor and host of Flip or Flop on HGTV. Teaching others the real estate investment business to build wealth and build the life they want to achie..."
  },

  // Guy Fieri
  "65718": {
    id: "65718",
    name: "Guy Fieri",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1658779243/production-TjoCZY/02a557660499e7d2cc44/1658779243.jpg",
    title: "Spokesperson at King's Hawaiian, Celebrity Chef",
    description:
      "Guy Fieri is an Emmy Award–winning television host, restaurateur, and author, best known for his larger-than-life personality and signature spiky blond hair. Born in Columbus, Ohio..."
  },

  // Matt Fox
  "159608": {
    id: "159608",
    name: "Matt Fox",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1751131596/production-TjoCZY/9a62eb5f5f07b77f5d51/1751131596.jpg",
    title:
      "Producer/Host/Designer/Craftsman/Spokesperson/ ... at Self",
    description:
      "Matt Fox – Television Host | Home &amp; Lifestyle Expert | Speaker Matt Fox is a nationally recognized television personality best known as the co-host of HGTV’s Room by Room, the..."
  },

  // Sarah Fraser
  "134450": {
    id: "134450",
    name: "Sarah Fraser",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1736883256/production-TjoCZY/ba6f1a5064ffc0c79200/1736883256.jpg",
    title: "Host and Creator at The Sarah Fraser Show",
    description:
      "For twenty years, media personality Sarah Fraser has made a name for herself with her bold, hilarious, and totally unfiltered takes on everything from pop culture to parenting, lif..."
  },

  // Jason Mitchell
  "90282": {
    id: "90282",
    name: "Jason Mitchell",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1720433556/production-TjoCZY/b5e3e0ad20883bd8cd88/1720433556.jpg",
    title: "Founder at Jason Mitchell Group",
    description:
      "Jason is the Founder at Jason Mitchell Group. He is a real estate powerhouse who founded Jason Mitchell Real Estate in 2006. Since, The Jason Mitchell Group (JMG) has achieved over..."
  },
  // Bradley Leake
  "82645": {
    id: "82645",
    name: "Bradley Leake",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1679392096/production-TjoCZY/af733536b63bdfc2b2c1/1679392096.jpg",
    title: "Celebrity Colorist & Hairstylist at Hair By Bradley Leake",
    description:
      "Bradley has under top Industry Professionals and started a successful business in the in the Midwest before relocating to Los Angeles in 2017. With 10 years of salon experience, Hi..."
  },
  // Jon Taffer
  "59088": {
    id: "59088",
    name: "Jon Taffer",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1587228159/production-TjoCZY/4ae92172b49616f4ebf8/1587228159.jpg",
    title: "Host and Executive Producer at Bar Rescue",
    description:
      "Jon Taffer is an internationally recognized hospitality expert, entrepreneur, and television personality with more than four decades of industry leadership. Best known as the creat..."
  },
  // Billy Prempeh
  "69482": {
    id: "69482",
    name: "Billy Prempeh",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1645768767/production-TjoCZY/61d76d76a38739fbacf5/1645768767.jpg",
    title: "Congressional Candidate at US Congressional Candidate",
    description:
      "Billy Prempeh was born in Paterson, New Jersey. He served in the United States Air Force from 2009 to 2011. Prempeh received an Associate Degree from the Community College of the A..."
  },
  // Richard Green
  "75183": {
    id: "75183",
    name: "Richard Green",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1669612131/production-TjoCZY/c99d391067074fdd9040/1669612131.jpg",
    title: "Chief Technology Officer at SugarCRM",
    description:
      "Richard is the Chief Technology Officer at SugarCRM. He leads SugarCRM’s engineering and product management teams and is responsible for the product vision and global strategy of t..."
  },
  // Andreas Welsch
  "15027": {
    id: "15027",
    name: "Andreas Welsch",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1719230467/production-TjoCZY/4f9207645de7b5b7d34d/1719230467.jpg",
    title: "Founder & Chief AI Strategist at Intelligence Briefing",
    description:
      "Andreas Welsch is an internationally recognized AI leader, advisor, and speaker known for helping the world’s leading enterprises turn technology hype into business outcomes. He..."
  },
  // Kate Rodgers
  "38391": {
    id: "38391",
    name: "Kate Rodgers",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1728478308/production-TjoCZY/d1cde35a07c882f6cca7/1728478308.jpg",
    title: "Global Brand Director at GE Healthcare",
    description:
      "Kate Rodgers is a seasoned marketing leader and speaker with a knack for storytelling and driving growth through creative campaigns. With experience ranging from tech startups to F..."
  },
   // Ashleigh Banfield
  "40543": {
    id: "40543",
    name: "Ashleigh Banfield",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1681843245/production-TjoCZY/a6e76bb07871c441cf3a/1681843245.jpg",
    title: "Host at NewsNation Network",
    description:
      "Award-winning veteran journalist Ashleigh Banfield is the host of “Banfield” on NewsNation. “Banfield” airs weeknights at 10 p.m. ET, offering in-depth coverage of the day’s top..."
  },
   // 
  "69974": {
    id: "69974",
    name: "Jeff Wong",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1561667665/production-TjoCZY/0a112d2ee0ba21373c1c/1561667665.jpg",
    title: "Global Chief Innovation Officer at EY",
    description:
      "As Global Chief Innovation Officer at EY, Jeff Wong helps companies harness disruptive technology and prepare for the future of work. He is passionate about preparing the next gene..."
  },
   // 
  "57414": {
    id: "57414",
    name: "Michele Parmelee",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1602950614/production-TjoCZY/789665805b43db9ad494/1602950614.jpg",
    title: "Deputy CEO and Chief People and Purpose Officer at Deloitte",
    description:
      "Chief People and Purpose Officer | Deloitte Global. Michele Parmelee is the Deloitte Global Chief People and Purpose Officer. In this role, she leads a broad portfolio of progra..."
  },
   // 60378
  "60378": {
    id: "60378",
    name: "Janet Truncale",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1614974556/production-TjoCZY/334fa8e95c33e9ef3474/1614974556.jpg",
    title: "Vice Chair and Regional Managing Partner, FSO at EY",
    description:
      "Janet Truncale is the Regional Managing Partner of the EY Americas Financial Services Organization (FSO). In this role, she leads a diverse team of more than 14,000 professionals a..."
  },
  // 62631
  "62631": {
    id: "62631",
    name: "Dan Helfrich",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1620202846/production-TjoCZY/8b17f1494647a5ba4f4e/1620202846.jpg",
    title: "Chairman and CEO at Deloitte Consulting",
    description:
      "Dan Helfrich is chairman and chief executive officer of Deloitte Consulting LLP. As CEO, he leads a team of more than 50,000 professionals who help clients solve their most complex..."
  },
  // 63521
  "63521": {
    id: "63521",
    name: "Dee Waddell",
    image:
      "https://res.cloudinary.com/hrsvcp9vu/v1620807894/production-TjoCZY/97950c7f6167e7ee4293/1620807893.jpg",
    title: "Global MD, Travel & Transportation at IBM",
    description:
      "Dee is a passionate and an award-winning leader of business, digital, and people-focused. His skills are unique combination of business and technology executive leadership especial..."
  },
};


// --- Helpers ---

export function getPreloadedExpertById(idLike) {
  if (idLike == null) return null;
  const key = String(idLike);
  return PRELOADED_EXPERTS[key] || null;
}

export function extractExpertId(expert = {}) {
  return (
    expert?.global_id ??
    expert?.globalId ??
    expert?.id ??
    null
  );
}

/**
 * Returns a merged copy of the runtime expert with any preloaded fields.
 * Preloaded values WIN (so they render immediately).
 */
export function hydrateExpertFromPreload(expert = {}) {
  const id = extractExpertId(expert);
  const pre = getPreloadedExpertById(id);
  if (!pre) return expert;

  return {
    ...expert,
    // normalize commonly used fields in your component
    name: pre.name ?? expert.name,
    profile_image_url: pre.image ?? expert.profile_image_url,
    featured_title_at_company: pre.title ?? expert.featured_title_at_company,
    headline: expert.headline ?? pre.title, // fallback path if you ever read headline
    description: pre.description ?? expert.description,
    // keep original slug/company/etc if present
  };
}

/**
 * Utility for upstream data layers:
 * Given an array of ids (e.g., from PARAMS.vip_all), return hydrated shells
 * you can show immediately while the real search fetches.
 */
export function makeInstantShellsFromIds(idList = []) {
  return idList
    .map(id => String(id).trim())
    .filter(Boolean)
    .map(id => {
      const pre = getPreloadedExpertById(id);
      if (!pre) return null;
      return {
        // Shape to match your Expert model as much as possible
        id: pre.id,
        global_id: pre.id,
        name: pre.name,
        profile_image_url: pre.image,
        featured_title_at_company: pre.title,
        description: pre.description,
        // Mark as shell so your DataProvider can reconcile/replace later
        __preloaded: true,
      };
    })
    .filter(Boolean);
}
